import { useMenu } from 'context/MenuContext';
import useOnClickOutside from 'models/utils/useOnClickOutside';
import { useRef } from 'react';
import Product from './product';
import styles from './styles.module.scss';
import orderArray from './order';
import Application from 'models/Application';

type Sidenav = {
  onClick: () => void;
}

function Sidenav(props : Sidenav) : JSX.Element {
  const { menu, isUndefined } = useMenu();
  const ref = useRef(null);

  useOnClickOutside(ref, props.onClick, ['react-select', 'biobar-sidenav', 'biobar-product']);

  const orderMenu = () : Array<Application> => {
    if(isUndefined())
      return [];

    menu.applications.forEach((x) => {
      const order = orderArray.filter(y => y.productName == x.applicationName);

      if(!order || order.length == 0) {
        x.order = 99;
        return x;
      }

      x.order = order[0].order;
      return x;
    });

    return sortMenu();
  };

  const sortMenu = () : Array<Application> => {
    menu.applications.sort((previous, current) => {
      if(previous.order > current.order)
        return 1;

      return previous.order < current.order ? -1 : 0;
    });

    return menu.applications;
  };

  return (
    <div ref={ref} className={styles['biobar-sidenav']}>
      {orderMenu().map((product, i) => {
        return <Product {...product} key={i} />;
      })}
    </div>
  );
}

export default Sidenav;